var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "codeComp" }, [
    _c(
      "div",
      { staticClass: "box prelative" },
      [
        _c("div", [_vm._v("VIP- oder Gutschein-Code eingeben:")]),
        _c(
          "div",
          { staticClass: "pt-2 d-flex align-center" },
          [
            _c("v-text-field", {
              staticClass: "nolabel noMargin rounded100",
              attrs: {
                placeholder: "",
                illed: "",
                "hide-details": "",
                required: "",
              },
              model: {
                value: _vm.code,
                callback: function ($$v) {
                  _vm.code = $$v
                },
                expression: "code",
              },
            }),
            _c(
              "div",
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "btn-mini ml-1",
                    nativeOn: {
                      "&click": function ($event) {
                        return _vm.checkCode.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(" einlösen ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm.showList ? _c("ListEnteredCodes") : _vm._e(),
        _vm.loading ? _c("BoxLoading") : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }